'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function noop(..._) { }

exports.noop = noop;
